import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _quillClasses from "../dict/quillClasses.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _stlFunc from "../functions/profiles/ebuStl.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const stlFunc = _stlFunc;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToHtml = _convertToHtml;
const quillClasses = _quillClasses;
const convertToPlainText = _convertToPlainText;
export default {
  decode: function (input, options) {
    let events = [],
      ttiInfo,
      ccEvent,
      colorTag = "",
      colorOpen = false,
      currentColor = "white",
      bgTag = "",
      bgOpen = false,
      boldOpen = false,
      italicOpen = false,
      underlineOpen = false,
      decodingOptions = getFormatOptions(options.formatOptions),
      accentInfo = {
        set: false,
        value: ""
      };
    let gsi = stlFunc.decodeGsiBlock(input.substring(0, 2048));
    let maxRows = parseInt(gsi.maxLines) || 23;
    let maxCols = parseInt(gsi.maxCharPerLine) || 40;

    // console.log(gsi);

    let ttiBlocks = input.substring(2048, input.length).match(/.{1,256}/g);
    //if a ttiBlock starts with characters "8f" we need to extract those characters and append them to the previous block. For example, if a ttiBlock is "8f8f8f138900..." we need to remove the "8f8f8f" and append it to the previous block.
    for (let i = 1; i < ttiBlocks.length; i++) {
      while (ttiBlocks[i].startsWith("8f")) {
        let match = ttiBlocks[i].match(/^(8f)+/);
        let prefix = match[0];
        ttiBlocks[i] = ttiBlocks[i].substring(prefix.length);
        ttiBlocks[i - 1] = ttiBlocks[i - 1] + prefix;
      }
    }

    // console.log(JSON.stringify(ttiBlocks, null, 4));
    //console.log(decodingOptions);

    /* New Background (0x1D): the background takes on the current foreground color */
    const openBackground = () => {
      if (colorOpen) {
        /* If the foreground tag was just opened with no text after it, remove it instead of leaving an empty tag pair */
        if (ccEvent.text.endsWith(`<${colorTag}>`)) {
          ccEvent.text = ccEvent.text.slice(0, -(colorTag.length + 2));
        } else {
          ccEvent.text += `</${colorTag}>`;
        }
        colorTag = "";
        colorOpen = false;
      }
      if (bgOpen) {
        ccEvent.text += `</${bgTag}>`;
      }
      bgTag = "bg" + currentColor.charAt(0).toUpperCase() + currentColor.slice(1);
      ccEvent.text += `<${bgTag}>`;
      bgOpen = true;
    };

    /* Black Background (0x1C): black is the default background so no new tag is opened */
    const closeBackground = () => {
      if (bgOpen) {
        ccEvent.text += `</${bgTag}>`;
        bgTag = "";
        bgOpen = false;
      }
    };
    ttiBlocks.forEach(ttiBlock => {
      ttiInfo = stlFunc.decodeTtiBlock(ttiBlock);
      if (ttiInfo.commentFlag === "00") {
        // console.log("---------"+events.length+"----------");
        // console.log(ttiInfo);
        ccEvent = new Event();
        ccEvent.start = tcLib.tcClockToSec(stlFunc.decodeTc(ttiInfo.incode), gsi.frameRate);
        ccEvent.end = tcLib.tcClockToSec(stlFunc.decodeTc(ttiInfo.outcode), gsi.frameRate);

        // console.log(ccEvent.start, ccEvent.end);
        ttiInfo.text.match(/.{1,2}/g).forEach((char, i, chars) => {
          // console.log(char);
          if (char === "0e" && chars[i + 1] && chars[i + 1]) {
            if (chars[i + 1] === "00") {
              chars.splice(i + 1, 1);
              return;
            }
            /* Unicode Thai Character */
            let thaiChar = char + chars[i + 1];
            // console.log(thaiChar + ": " + String.fromCharCode(parseInt(thaiChar, 16)));
            ccEvent.text += String.fromCharCode(parseInt(thaiChar, 16));
            chars.splice(i + 1, 1);
            return;
          }
          if (char === "8f" || char === "f8") {
            /* Control Code */
            return;
          } else if (parseInt(char, 16) >= 0 && parseInt(char, 16) <= 31) {
            /* TELETEXT CONTROL CODES */
            if (stlFunc.cntrlCodes[char]) {
              ccEvent.colors += 1;
              currentColor = stlFunc.cntrlCodes[char];
              if (decodingOptions['Decode Speakers By Color'] && decodingOptions['Decode Speakers By Color'] !== "false") {
                if (decodingOptions['Insert Speaker Identifier'] && decodingOptions['Insert Speaker Identifier'] !== "false" && ccEvent.color !== stlFunc.cntrlCodes[char] && ccEvent.colors > decodingOptions['Speaker Is Greater Than']) {
                  ccEvent.text = decodingOptions['Speaker Identifier'] + ccEvent.text.trim();
                  ccEvent.text += "\n" + decodingOptions['Speaker Identifier'];
                }
                ccEvent.color = stlFunc.cntrlCodes[char];
              } else {
                //console.log("COLOR:", stlFunc.cntrlCodes[char]);
                if (colorOpen) {
                  ccEvent.text += `</${colorTag}>`;
                }
                ccEvent.text += `<${stlFunc.cntrlCodes[char]}>`;
                colorTag = stlFunc.cntrlCodes[char];
                colorOpen = true;
              }
            } else if (char === "1d") {
              openBackground();
            } else if (char === "1c") {
              closeBackground();
            } else {
              // console.log("CMD CODE: " +char);
            }
          } else if (parseInt(char, 16) >= 32 && parseInt(char, 16) <= 127 || parseInt(char, 16) >= 161 && parseInt(char, 16) <= 255) {
            if (gsi.alphabet.toLowerCase() === 'latin' && parseInt(char, 16) !== 201 && parseInt(char, 16) !== 204 && parseInt(char, 16) >= 193 && parseInt(char, 16) <= 207) {
              /* EBU STL uses a floating accent principle so we need to store the accents as they come in and apply them on the next character. See document for more info. */
              accentInfo = {
                set: true,
                value: parseInt(char, 16)
              };
              //console.log(accentInfo);
            } else {
              if (accentInfo.set) {
                //console.log(char.toLowerCase(), accentInfo.value)
                if (stlFunc.accentMapping[char.toLowerCase()] && stlFunc.accentMapping[char.toLowerCase()][accentInfo.value]) {
                  ccEvent.text += stlFunc.accentMapping[char.toLowerCase()][accentInfo.value];
                } else {
                  ccEvent.text += "*";
                }
                accentInfo.set = false;
              } else if (stlFunc.specialChars[char]) {
                //console.log(parseInt(char, 16) + " : " + stlFunc.decodeChar(char, stlFunc.codePageMapping[gsi.alphabet]));
                ccEvent.text += stlFunc.specialChars[char];
              } else {
                //console.log(parseInt(char, 16) + " : " + stlFunc.decodeChar(char, stlFunc.codePageMapping[gsi.alphabet]));
                ccEvent.text += stlFunc.decodeChar(char, stlFunc.codePageMapping[gsi.alphabet]);
              }
            }
          } else if (parseInt(char, 16) >= 128 && parseInt(char, 16) <= 133) {
            /* Format Codes */
            if (stlFunc.controlCodeMapping[char]) {
              if (stlFunc.controlCodeMapping[char] === "<i>") {
                if (!italicOpen) {
                  ccEvent.text += stlFunc.controlCodeMapping[char];
                  italicOpen = true;
                }
              } else if (stlFunc.controlCodeMapping[char] === "<u>") {
                if (!underlineOpen) {
                  ccEvent.text += stlFunc.controlCodeMapping[char];
                  underlineOpen = true;
                }
              } else if (stlFunc.controlCodeMapping[char] === "<b>") {
                if (!boldOpen) {
                  ccEvent.text += stlFunc.controlCodeMapping[char];
                  boldOpen = true;
                }
              } else if (stlFunc.controlCodeMapping[char] === "</i>") {
                if (italicOpen) {
                  ccEvent.text += stlFunc.controlCodeMapping[char];
                  italicOpen = false;
                }
              } else if (stlFunc.controlCodeMapping[char] === "</u>") {
                if (underlineOpen) {
                  ccEvent.text += stlFunc.controlCodeMapping[char];
                  underlineOpen = false;
                }
              } else if (stlFunc.controlCodeMapping[char] === "</b>") {
                if (boldOpen) {
                  ccEvent.text += stlFunc.controlCodeMapping[char];
                  boldOpen = false;
                }
              }
            }
          } else if (parseInt(char, 16) === 138 /* 8A */) {
            /* Insert New Line - color and background states hard-reset at the start of each row */
            if (colorOpen) {
              ccEvent.text += `</${colorTag}>`;
              colorTag = "";
              colorOpen = false;
            }
            closeBackground();
            currentColor = "white";
            ccEvent.text = ccEvent.text + "\n";
          } else if (char === "9d") {
            /* New Background with odd-parity bit set (0x1D | 0x80) */
            openBackground();
          } else if (char === "9c") {
            /* Black Background with odd-parity bit set (0x1C | 0x80) */
            closeBackground();
          }
        });
        if (boldOpen) {
          ccEvent.text += stlFunc.controlCodeMapping["85"];
          boldOpen = false;
        }
        if (underlineOpen) {
          ccEvent.text += stlFunc.controlCodeMapping["83"];
          underlineOpen = false;
        }
        if (italicOpen) {
          ccEvent.text += stlFunc.controlCodeMapping["81"];
          italicOpen = false;
        }
        if (colorOpen) {
          ccEvent.text += `</${colorTag}>`;
          colorTag = "";
          colorOpen = false;
        }
        closeBackground();
        currentColor = "white";
        accentInfo.set = false;
        let plainText = convertToPlainText(ccEvent.text);
        let lines = plainText.split("\n");
        let totalLines = lines.length;

        /* Set alignment and xPos */
        if (ttiInfo.xPos === "start") {
          ccEvent.alignment = "left";
          ccEvent.xPos = "start";
        } else if (ttiInfo.xPos === "end") {
          ccEvent.alignment = "right";
          ccEvent.xPos = "end";
        } else {
          ccEvent.alignment = "center";
          ccEvent.xPos = "center";
        }
        if (ccEvent.xPos === "start") {
          let lineMetrics = [];
          ccEvent.text.split("\n").forEach(line => {
            let cleanLine = line.replace(/<[^>]+>/g, "");
            if (cleanLine.trim().length === 0) {
              return;
            }
            let leading = (cleanLine.match(/^ */) || [""])[0].length;
            let len = cleanLine.trim().length;
            let trailing = (cleanLine.match(/ *$/) || [""])[0].length;
            lineMetrics.push({
              leading: leading,
              len: len,
              trailing: trailing,
              lineEnd: leading + len,
              lineCenter: leading + len / 2
            });
          });
          if (lineMetrics.some(line => line.leading > 0)) {
            let leftGap = Math.min(...lineMetrics.map(line => line.leading));
            let hasTrailingPadding = lineMetrics.some(line => line.trailing > 0);
            let rightGap = hasTrailingPadding ? Math.min(...lineMetrics.map(line => line.trailing)) : maxCols - Math.max(...lineMetrics.map(line => line.lineEnd));
            if (Math.abs(leftGap - rightGap) <= 2) {
              ccEvent.xPos = "center";
            } else if (rightGap < leftGap) {
              ccEvent.xPos = "end";
            } else {
              ccEvent.xPos = "start";
            }
            let allNear = values => {
              if (values.length <= 1) {
                return true;
              }
              let minVal = Math.min(...values);
              let maxVal = Math.max(...values);
              return maxVal - minVal <= 1;
            };
            if (lineMetrics.length === 1) {
              if (ccEvent.xPos === "start") {
                ccEvent.alignment = "left";
              } else if (ccEvent.xPos === "end") {
                ccEvent.alignment = "right";
              } else {
                ccEvent.alignment = "center";
              }
            } else if (allNear(lineMetrics.map(line => line.leading))) {
              ccEvent.alignment = "left";
            } else if (allNear(lineMetrics.map(line => line.lineEnd))) {
              ccEvent.alignment = "right";
            } else if (allNear(lineMetrics.map(line => line.lineCenter))) {
              ccEvent.alignment = "center";
            } else if (ccEvent.xPos === "start") {
              ccEvent.alignment = "left";
            } else if (ccEvent.xPos === "end") {
              ccEvent.alignment = "right";
            } else {
              ccEvent.alignment = "center";
            }
          }
        }

        /* Set yPos */
        /* 
            In order to calculate the vertical position (yPos) of the Event, we need to look at the yPos integer in the ttiInfo, the max rows, and whether the ttiInfo is double height or not. Closed Caption Creator doesn't really have a concept of double height the same way EBU-STL caption files do so we need to take this into account as we convert everything to single height. The ttInfo.yPos is the row address in the STL file. The maximum number of rows is set by the maxRows variable. For example, if a ttiInfo block has a yPos of 21 and the max rows is 21 we know that the subtitle is at the bottom of the screen (ccEvent.yPos = `end`). If the yPos of the ttiInfo block is at 1 we can assume the yPos of the subtitle is at the top of the screen (ccEvent.yPos = `start`). If the yPos of the ttInfo is between 1 and the maxRows, we'll need to look at the the totalLines, and whether the ttiInfo is double height or not. Here is the step-by-step process we should follow when calculating the vertical position of an Event.
                1. Get starting row value (ttiInfo.yPos)
                    - If the starting row is 1, set ccEvent.yPos to 'start'
                2. Calculate the size and ending row value: size = totalLines*(doubleHeight ? 2 : 1)); endingRow = startingRow + size;
                    - If the ending row >= maxRows set the ccEvent.yPos to 'end'. 
                    - If the startingRow === (maxRows-size)/2 set the ccEvent.yPos to `center`
                3. If the ending row < maxRows, convert the starting row number to a percentage of the total rows and calculate the yPos offset based on the window height:  ((startingRow/totalRows) * window.height)
                    - If the integer 
        */
        // Step 1: Get starting row value
        let startingRow = ttiInfo.yPos + 1; // +1 because STL rows are 0 indexed

        // Step 2: Calculate size and ending row value
        let size = totalLines * (ttiInfo.doubleHeight ? 2 : 1);
        let endingRow = startingRow + size;

        // Check position based on the step-by-step process
        if (startingRow === 1) {
          ccEvent.yPos = "start";
        } else if (endingRow >= maxRows) {
          ccEvent.yPos = "end";
        } else if (startingRow === Math.floor((maxRows - size) / 2)) {
          ccEvent.yPos = "center";
        } else {
          // Step 3: Calculate percentage-based position
          let yPosPercent = startingRow / maxRows * 100;
          ccEvent.yPos = Math.floor(options.window.height * yPosPercent / 100);
          if (ccEvent.yPos < 2) {
            ccEvent.yPos = 'start';
          }
        }
        ccEvent.text = convertToHtml(ccEvent.text.replace(/ +/gmi, " ").replace(/^ +/gmi, ""), [quillClasses.align[ccEvent.alignment]]);
        // console.log(ccEvent.text, ccEvent.start, ccEvent.end);

        events.push(ccEvent);
      }
    });

    // console.log(JSON.stringify(events, null, 4));

    return events;
  },
  encode: function (eventGroup, options) {
    let output = "",
      gsi,
      encodingOptions = getFormatOptions(options.formatOptions),
      tti;

    // console.log(encodingOptions);

    if (encodingOptions["Include Blank Subtitle At Start"] && encodingOptions["Include Blank Subtitle At Start"] === "yes") {
      let som = encodingOptions["SOM"] || options.incode || "00:00:00:00";
      let blankEvent = new Event({
        start: tcLib.tcClockToSec(som, options.frameRate),
        end: tcLib.tcClockToSec(som, options.frameRate) + 5 / options.frameRate,
        text: convertToHtml("", [quillClasses.align.center])
      });
      eventGroup.events.unshift(blankEvent);
    }
    gsi = stlFunc.encodeGsiBlock(eventGroup.events, encodingOptions, options);
    // console.log(gsi);
    output += gsi.concat();
    eventGroup.events.forEach(function (event, index) {
      // console.log("----------------");
      // console.log(event.text);
      tti = stlFunc.encodeTtiBlock(event, index, encodingOptions, options);
      output += tti.concat();
    });
    return output;
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      eventGroup.events = eventGroup.events.filter((event, index, events) => {
        if (events[index + 1]) {
          if (event.start === events[index + 1].start && event.end === events[index + 1].end) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      });

      // console.log(JSON.stringify(eventGroup, null, 4));
      return eventGroup;
    }
  }
};